/*
Item: Access Denied Page
Name: Access
Format: Page, full screen
*/

import React, { Component } from 'react';
import { Button } from 'primereact/button';

export default class Access extends Component {
  render() {
    return (
      <div className="exception-body accessdenied">
        <div className="exception-panel">
          <div className="exception-code">
            <img
              src={
                `${process.env.PUBLIC_URL}/assets/layout/images/exception/401.svg`
              }
              alt="adbhsstat"
            />
          </div>

          <div className="exception-detail">
            <div className="exception-icon">
              <i className="material-icons">verified_user</i>
            </div>
            <h1>ACCESS DENIED</h1>
            <p>Please contact the system administrator</p>

            <Button
              label="GO TO DASHBOARD"
              onClick={() => {
                window.location = '/#';
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
